import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';

import { Content, TxScMsg } from '../../../_models';
import {AuthenticationService, NotificationService, ContentService, TxMsgService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sc-msg-detail',
  templateUrl: './msg-detail.component.html',
  styleUrls: []
})
export class ScMsgDetailComponent implements OnInit {

  msgData: TxScMsg = null;
  loaded = false;
  loading = true;
  processing = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private txMsgSvc: TxMsgService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.loadDetail(id);
  }


  save() {
    this.processing = true;
    if (confirm("Are you sure to update this template?")) {
      this.txMsgSvc.updateScMsg(this.msgData).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Template updated successfully!", "Update Template");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update template, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/tx/sc-msg']);
  }

  private loadDetail(id){
    this.txMsgSvc.getScMsg(id).subscribe(data => {
      this.msgData = data
      this.loaded = true;
      this.loading = false;
    });
  }

}
